import { ReactNode } from 'react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
};

/**
 * A real empty state. The production table's equivalent is the bare string
 * "No data in table" in a colspan cell — which tells a user nothing about
 * whether the filters are too narrow, the data has not loaded, or there is
 * genuinely nothing there.
 */
export const EmptyState = ({ icon, title, hint, action }: EmptyStateProps) => (
  <div className="ds-empty">
    {icon && <div className="ds-empty-icon">{icon}</div>}
    <div className="ds-empty-title">{title}</div>
    {hint && <p className="ds-empty-hint">{hint}</p>}
    {action && <div style={{ marginTop: 8 }}>{action}</div>}
  </div>
);
